import React, { FC, useEffect } from 'react'
import classNames from 'classnames'
import { setAlgoliaQueryIDInLocalStorage } from 'lib/algolia/v2/helpers'
import Breadcrumb from 'components/SA/Breadcrumb'
import { slugify } from 'lib/slugify'
import { splitAndCapitalizeString } from 'lib/helpers'

import styles from './Feature.module.scss'
import AppConnector, { ConnectorProps as AppProps } from '../connectors/App'
import FeaturePolaroidList from '../components/artworks/FeaturePolaroidList'
import FeatureListPagination from '../components/artworks/Pagination'

const Layout: FC<AppProps> = ({ queryID, title, category, keyword }) => {
  useEffect(() => {
    // store ALGOLIA_QUERY_ID in local storage
    setAlgoliaQueryIDInLocalStorage(queryID)
  })

  const capitalizedKeyword = splitAndCapitalizeString(keyword)

  return (
    <div className={styles.featureWrapper}>
      <div className={classNames(styles.featurePaddingContainer, styles.breadcrumbHeaderContainer)}>
        <Breadcrumb
          items={[
            {
              name: 'Home',
              title: 'Home',
              url: '/',
            },
            {
              name: category,
              title: `See artworks in ${category}`,
              url: `/${slugify(category)}`
            },
            {
              name: capitalizedKeyword,
              title: capitalizedKeyword,
            }
          ]}
        />
        <h1 className='defaultTypographyH4' data-style='header'>
          {`Results for "${title}" ${category}`}
        </h1>
      </div>
      <div className={styles.mainContentGrid}>
        <FeaturePolaroidList isAlgoliaLoading={false} />
      </div>
      <div className={classNames(styles.featurePaddingContainer, styles.paginationContainer)}>
        <FeatureListPagination />
      </div>
    </div>
  )
}

export default AppConnector(Layout)
